import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Center, Row } from '../../../style/basic/commonStyle';
import BasicText from '../../basic/BasicText';
import { apiGetMyInfo, apiSetMyInfoUpdate } from '../../../api/api_mypage';
import { useUserInfo } from '../../../utils/custom-hooks/common/useUserInfo';
import { onlyNumber } from '../../../utils/format/string';
import isEmail from 'validator/lib/isEmail';

const Item = ({title,value,valueChange}:any) =>{
    return (
        <ItemWrap>
            <BasicText marginLeft={1}>{title}</BasicText>
            <InputWrap>
                <input required value={value} onChange={valueChange}></input>
            </InputWrap>
        </ItemWrap>
    )
}

export default function MyInfoUpdatePage() {
    const userInfo = useUserInfo();
    const [info,setInfo] = useState({
        "user_id": 0,
        "user_sign_type": "1",
        "user_name": "",
        "user_phone_number": " ",
        "user_email": " ",
        "user_timestamp": 0,
        "user_last_timestamp": 0
    });

    useEffect(()=>{
        if(userInfo.user_id === 0) return;
        getInfo();
    },[userInfo.user_id])

    const getInfo = async() =>{
        const res = await apiGetMyInfo(userInfo.token,userInfo.user_id);
        if(res.result){
            setInfo(res.data);
        }
    }

    const valueChange = (name:string,val:any) =>{
        setInfo((obj:any)=>({
            ...obj,
            [name]: val,
        }))
    }

    const updateAction = async(e:any) =>{
        e.preventDefault();
        if(info.user_name === ''){
            alert('이름을 입력해주세요.');
            return
        }
        if(info.user_phone_number === ''){
            alert('전화번호를 입력해주세요.');
            return;
        }
        if(info.user_email === '' || !isEmail(info.user_email)){
            alert('이메일을 확인해주세요.');
            return;
        }
        const res = await apiSetMyInfoUpdate(userInfo.token,userInfo.user_id,info.user_name,info.user_phone_number,info.user_email);
        if(res.result){
            alert('내 정보를 수정했습니다.');
        }else{
            alert(res.error);
        }
    }

    return (
        <Wrap onSubmit={updateAction}>
            <ContentWrap>
                <Item title='이름' value={info.user_name} valueChange={(e:any)=>valueChange('user_name',e.target.value)}></Item>
                <Item title='전화번호' value={info.user_phone_number} valueChange={(e:any)=>valueChange('user_phone_number',onlyNumber(e))}></Item>
                <Item title='이메일' value={info.user_email} valueChange={(e:any)=>valueChange('user_email',e.target.value)}></Item>
            </ContentWrap>
            <Center>
                <BtnItem type='submit'>정보 수정</BtnItem>
            </Center>
        </Wrap>
    )
}

const Wrap = styled.form``;
const ContentWrap = styled(Row)`
    align-items: start;
    gap: 18px;
    flex-direction: column;
`;
const ItemWrap =  styled.div`
    width: 100%;
`;

const BtnItem = styled.button`
    margin-top: 40px;
    width: 160px;
    height: 46px;
    background-color: #F5F5F5;
    border-radius: 8px;
    color: #2A2A2A;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const InputWrap = styled.div`
    margin-top: 6px;
    & input{
        width: 100%;
        background-color: #F5F5F5;
        border: 1px solid #DEDEDE;
        border-radius: 5px;
        padding: 10px;
    }
`;